import * as Yup from 'yup';

declare module 'yup' {
  interface ObjectSchema<T> {
    uniqueProperty(propertyName: string, message: string): this;
  }
}

Yup.addMethod(Yup.object, 'uniqueProperty', function (propertyName, message) {
  return this.test('unique-property', message, function (value) {
    if (!value || !value[propertyName]) return true;

    const { path } = this;
    const options = this.parent ?? [];

    const normalized = (s?: string | number): string =>
      s != null ? String(s).trim().toLowerCase() : '';

    const current = normalized(value[propertyName]);

    const hasDuplicate = options
      .filter((option: any) => option !== value)
      .some((option: any) => normalized(option[propertyName]) === current);

    if (hasDuplicate) {
      return this.createError({
        path: `${path}.${propertyName}`,
        message,
      });
    }

    return true;
  });
});
